<template>
  <svg style="vertical-align:sub" :alt="alt" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-eyeglasses"
       v-bind:class="[active ? 'active' : 'inactive']" fill="currentColor"
       xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd"
          d="M4 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm2.625.547a3 3 0 0 0-5.584.953H.5a.5.5 0 0 0 0 1h.541A3 3 0 0 0 7 8a1 1 0 0 1 2 0 3 3 0 0 0 5.959.5h.541a.5.5 0 0 0 0-1h-.541a3 3 0 0 0-5.584-.953A1.993 1.993 0 0 0 8 6c-.532 0-1.016.208-1.375.547zM14 8a2 2 0 1 0-4 0 2 2 0 0 0 4 0z"/>
  </svg>
</template>


<script>
export default {
  props: {
    active: {type: String},
    alt: {type: String}
  },
}
</script>
<style scoped>
svg.active {
  color: #0078b6 !important;
}

svg.inactive {
  color: #dee5ea !important;
}
</style>